
import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	template: `
		<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()">
			<p>Включить пользователя {{ this.title }} в фильтр "Исключить из статистики"?</p>
		</base-support-modal>
	`
})	
export class SetExcludeFromStatsComponent extends BaseSupportModalComponent {
	userId: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите добавить юзера: ${this.userId} в фильтр?`)) {
			await this.supportService.setExcludeFromStats(this.userId, this.comment).toPromise();

			this.execute();
		}
	}
}

